// app/getQueryClient.tsx
import { QueryClient } from '@tanstack/react-query'

// cache() is scoped per request, so we don't leak data between requests
const getQueryClient =  new QueryClient()
export default getQueryClient